<template>
  <div>
    <ModuleHeader> {{ nombre }}</ModuleHeader>
    <v-row>
      <v-col>
        <h4 class="mt-n4">Saldo en pesos : {{ saldoConverse }} {{$Currencies.getCurrencyDefault()}}</h4>
      </v-col>
      <v-col>
        
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12" md="12">
        <v-text-field
        class="mb-n5"
          v-model="descripcion"
          label="Descripción"
        >
        </v-text-field>
      </v-col>
      <v-col col="12" md="5">
        <v-text-field
          v-model="cantidad"
          @keypress="$pgsHelper.onlyNumber($event, cantidad)"
          label="Cantidad"
        >
        </v-text-field>
      </v-col>
      <v-col col="12" md="5">
        <v-select
          disabled
          v-model="tipo"
          :items="[{value:'D',text:'Deposito'},{value:'R',text:'Retiro'}]"
        >
        </v-select>
      </v-col>
      <v-col col="12" md="2">
        <v-btn
          @click="addMov()"
          color="primary"
        >
          Agregar
        </v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Movimiento</th>
          <th>Cantidad</th>
          <th>Cantidad MXN</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(producto, index) in movimientos">
          <tr :key="index">
            <td>{{ producto.Descripcion }}</td>
            <td>{{ producto.Cantidad }} p</td>
            <td>{{ producto.Cantidad * 1 }} MXN</td>
            <td>
              <i
                v-if="producto._Op == 'R'"
                style="font-size: 20px; color: red"
                class="lni lni-arrow-down-circle"
              ></i>
              <i
                v-if="producto._Op == 'D'"
                style="font-size: 20px; color: green"
                class="lni lni-arrow-up-circle"
              ></i>
            </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
//const $ = require('jquery');
//window.$ = $;
import moment from "moment";

//import axiosCore from 'axios'

export default {
  name: "FormMonedero",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      nombre: "",
      saldo: "",
      saldoConverse: "",
      movimientos: [],
      descripcion: "",
      cantidad: "",
      tipo: "R",

      Id: "",
      errors: {},
      loader: true,
    };
  },
  methods: {
    addMov() {
      let datos = {
        Id: this.Id,
        Movimientos: [
          {
            Fecha: new moment().format("YYYY-MM-DD"),
            Cantidad: parseInt(this.cantidad),
            Descripcion: this.descripcion,
            _Op: this.tipo,
          },
        ],
      };
      this.$swal({
        allowOutsideClick: false,
        title: "¿Deseas agregar este movimiento?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Monederos-agregarMovimientos", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {

        if (result.value) {
          // this.$emit('reloadClient');

          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El movimiento se guardo correctamente",
              icon: "success",
            }).then(() => {
              if (datos.Movimientos[0]._Op != "R") {
                this.movimientos.push(datos.Movimientos[0]);
                this.saldo = this.saldo + datos.Movimientos[0].Cantidad;
                this.saldoConverse =
                  this.saldoConverse + datos.Movimientos[0].Cantidad * 1;
              }else{
                this.movimientos.push(datos.Movimientos[0]);
                this.saldo = this.saldo - datos.Movimientos[0].Cantidad;
                this.saldoConverse =
                  this.saldoConverse - datos.Movimientos[0].Cantidad * 1;
              }
              this.descripcion = "";
              this.cantidad = "";
            });
            this.$emit("reloadClients");
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre del cupón es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.mayorista) {
        this.errors.mayorista = "La agencia es obligatoria";
        valid = false;
      } else {
        this.errors.mayorista = false;
      }

      if (!this.cuponesIlimitados) {
        if (!this.cantidad) {
          this.errors.cantidad = "La cantidad de cupones es obligatoria";
          valid = false;
        } else {
          this.errors.cantidad = false;
        }
      }

      if (this.costoCupon.toString() == "") {
        this.$pgsHelper.log("invalido");
        this.errors.costoCupon = "el costo del cupón es obligatorio";
        valid = false;
      } else {
        this.$pgsHelper.log("valido");
        this.errors.costoCupon = false;
      }

      if (this.productos.length == 0) {
        this.errors.Producto = "Agregue al menos un producto";
        valid = false;
      } else {
        this.errors.Producto = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {
    this.loader = true;
  },
  mounted() {
    this.loader = false;

    if (this.edit) {
      this.Id = this.dataEdit.Id;
      this.nombre = this.dataEdit.getNombreCompleto();
      this.saldo = this.dataEdit.Monedero.Saldo;
      this.saldoConverse = this.dataEdit.SaldoConversion;
      this.movimientos = this.dataEdit.Monedero.UMovimientos.reverse();
    }
  },
};
</script>